<template>
    <div>
        <router-view />
    </div>
</template>
<script>
import ConfigManager from "@/config/ConfigManager.js";
import FBFunction from './helper/facade/FBFunction';
//store
import SideMenuStore from "@/store/SideMenuStore.js";
import AccountStore from "@/store/AccountStore.js";
//service
import FbAuthApi from './core/Account/service/FbAuthApi';

export default {
    created: function() {
        console.log("run local environment", ConfigManager.getApi());
        AccountStore.methods.init();
        // this.initFacebook();
    },
    provide: {
        SideMenuStore: SideMenuStore,
        AccountStore: AccountStore,
    },
    methods: {
        initFacebook: function() {
            let fb = new FBFunction()
            fb.getLoginStatus().then((res) => {
                console.log('fb', res);
                FbAuthApi.apiLoginFacebook(res.accessToken).subscribe({
                    next: (data) => {
                        console.log('login fb', data);
                    },
                    error: (err) => {
                        console.log('login fb', err);
                    },
                });
            }).catch(() => {
                // not login facebook
            });
        },
    },
}
</script>
<style lang="scss">
    @import "./style/base/base.scss";
    @import "./style/main.scss";
</style>
